var Ge = Object.defineProperty;
var Be = (t, e, s) => e in t ? Ge(t, e, { enumerable: !0, configurable: !0, writable: !0, value: s }) : t[e] = s;
var L = (t, e, s) => Be(t, typeof e != "symbol" ? e + "" : e, s);
import { shallowRef as Ue, defineComponent as X, openBlock as h, createBlock as Ie, Transition as Pe, normalizeProps as Te, guardReactiveProps as _e, withCtx as se, resolveDynamicComponent as je, mergeProps as Fe, createCommentVNode as f, createElementBlock as p, createVNode as ae, unref as o, onMounted as re, watch as C, getCurrentInstance as Ne, Fragment as Me, renderList as He, createElementVNode as i, renderSlot as We, createTextVNode as T, inject as Le, computed as ze, toRaw as ke, toDisplayString as y, withDirectives as Y, normalizeClass as Q, withKeys as Z, vModelText as ee, createApp as Ke } from "vue";
import { defineStore as Xe, createPinia as Je } from "pinia";
import Ae from "axios";
const W = Ue();
function we(t) {
  W.value && (W.value.resolve(t), W.value = void 0);
}
function Ye(t, e, s = "default") {
  return new Promise((a) => {
    W.value = {
      dialog: t,
      props: e,
      wrapper: s,
      resolve: a
    };
  });
}
const Qe = {
  install: (t, e) => {
    const s = function(a, n = void 0) {
      we(n !== void 0 ? n : a.returnValue());
    };
    t.provide("closeFunc", s), t.config.globalProperties.$close = s;
  }
}, Ze = X({
  name: "DialogWrapper",
  components: {},
  props: {
    name: {
      type: String,
      default: "default"
    },
    transitionAttrs: Object
  },
  setup(t, e) {
    return {
      dialogRef: W
    };
  }
}), et = (t, e) => {
  const s = t.__vccOpts || t;
  for (const [a, n] of e)
    s[a] = n;
  return s;
};
function tt(t, e, s, a, n, d) {
  return h(), Ie(Pe, Te(_e(t.transitionAttrs)), {
    default: se(() => [
      t.dialogRef && t.dialogRef.wrapper === t.name ? (h(), Ie(je(t.dialogRef.dialog), Te(Fe({ key: 0 }, t.dialogRef.props)), null, 16)) : f("", !0)
    ]),
    _: 1
  }, 16);
}
const st = /* @__PURE__ */ et(Ze, [["render", tt]]);
var at = Object.defineProperty, $e = (t) => {
  throw TypeError(t);
}, rt = (t, e, s) => e in t ? at(t, e, { enumerable: !0, configurable: !0, writable: !0, value: s }) : t[e] = s, u = (t, e, s) => rt(t, typeof e != "symbol" ? e + "" : e, s), De = (t, e, s) => e.has(t) || $e("Cannot " + s), g = (t, e, s) => (De(t, e, "read from private field"), s ? s.call(t) : e.get(t)), P = (t, e, s) => e.has(t) ? $e("Cannot add the same private member more than once") : e instanceof WeakSet ? e.add(t) : e.set(t, s), S = (t, e, s, a) => (De(t, e, "write to private field"), e.set(t, s), s);
class it {
  constructor(e) {
    u(this, "config"), this.config = e;
  }
}
function ot(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var nt = typeof self == "object" ? self.FormData : window.FormData;
const Oe = /* @__PURE__ */ ot(nt);
class G extends Error {
  constructor(e, s, a) {
    super(a), u(this, "url"), u(this, "status"), u(this, "statusText"), u(this, "body"), u(this, "request"), this.name = "ApiError", this.url = s.url, this.status = s.status, this.statusText = s.statusText, this.body = s.body, this.request = e;
  }
}
class lt extends Error {
  constructor(e) {
    super(e), this.name = "CancelError";
  }
  get isCancelled() {
    return !0;
  }
}
var $, D, R, _, F, H, j;
class dt {
  constructor(e) {
    P(this, $), P(this, D), P(this, R), P(this, _), P(this, F), P(this, H), P(this, j), S(this, $, !1), S(this, D, !1), S(this, R, !1), S(this, _, []), S(this, F, new Promise((s, a) => {
      S(this, H, s), S(this, j, a);
      const n = (m) => {
        g(this, $) || g(this, D) || g(this, R) || (S(this, $, !0), g(this, H) && g(this, H).call(this, m));
      }, d = (m) => {
        g(this, $) || g(this, D) || g(this, R) || (S(this, D, !0), g(this, j) && g(this, j).call(this, m));
      }, c = (m) => {
        g(this, $) || g(this, D) || g(this, R) || g(this, _).push(m);
      };
      return Object.defineProperty(c, "isResolved", {
        get: () => g(this, $)
      }), Object.defineProperty(c, "isRejected", {
        get: () => g(this, D)
      }), Object.defineProperty(c, "isCancelled", {
        get: () => g(this, R)
      }), e(n, d, c);
    }));
  }
  get [Symbol.toStringTag]() {
    return "Cancellable Promise";
  }
  then(e, s) {
    return g(this, F).then(e, s);
  }
  catch(e) {
    return g(this, F).catch(e);
  }
  finally(e) {
    return g(this, F).finally(e);
  }
  cancel() {
    if (!(g(this, $) || g(this, D) || g(this, R))) {
      if (S(this, R, !0), g(this, _).length)
        try {
          for (const e of g(this, _))
            e();
        } catch (e) {
          console.warn("Cancellation threw an error", e);
          return;
        }
      g(this, _).length = 0, g(this, j) && g(this, j).call(this, new lt("Request aborted"));
    }
  }
  get isCancelled() {
    return g(this, R);
  }
}
$ = /* @__PURE__ */ new WeakMap(), D = /* @__PURE__ */ new WeakMap(), R = /* @__PURE__ */ new WeakMap(), _ = /* @__PURE__ */ new WeakMap(), F = /* @__PURE__ */ new WeakMap(), H = /* @__PURE__ */ new WeakMap(), j = /* @__PURE__ */ new WeakMap();
const ie = (t) => t != null, J = (t) => typeof t == "string", te = (t) => J(t) && t !== "", xe = (t) => typeof t == "object" && typeof t.type == "string" && typeof t.stream == "function" && typeof t.arrayBuffer == "function" && typeof t.constructor == "function" && typeof t.constructor.name == "string" && /^(Blob|File)$/.test(t.constructor.name) && /^(Blob|File)$/.test(t[Symbol.toStringTag]), ct = (t) => t instanceof Oe, ut = (t) => t >= 200 && t < 300, ht = (t) => {
  try {
    return btoa(t);
  } catch {
    return Buffer.from(t).toString("base64");
  }
}, pt = (t) => {
  const e = [], s = (n, d) => {
    e.push(`${encodeURIComponent(n)}=${encodeURIComponent(String(d))}`);
  }, a = (n, d) => {
    ie(d) && (Array.isArray(d) ? d.forEach((c) => {
      a(n, c);
    }) : typeof d == "object" ? Object.entries(d).forEach(([c, m]) => {
      a(`${n}[${c}]`, m);
    }) : s(n, d));
  };
  return Object.entries(t).forEach(([n, d]) => {
    a(n, d);
  }), e.length > 0 ? `?${e.join("&")}` : "";
}, mt = (t, e) => {
  const s = t.ENCODE_PATH || encodeURI, a = e.url.replace("{api-version}", t.VERSION).replace(/{(.*?)}/g, (d, c) => {
    var m;
    return (m = e.path) != null && m.hasOwnProperty(c) ? s(String(e.path[c])) : d;
  }), n = `${t.BASE}${a}`;
  return e.query ? `${n}${pt(e.query)}` : n;
}, gt = (t) => {
  if (t.formData) {
    const e = new Oe(), s = (a, n) => {
      J(n) || xe(n) ? e.append(a, n) : e.append(a, JSON.stringify(n));
    };
    return Object.entries(t.formData).filter(([a, n]) => ie(n)).forEach(([a, n]) => {
      Array.isArray(n) ? n.forEach((d) => s(a, d)) : s(a, n);
    }), e;
  }
}, z = async (t, e) => typeof e == "function" ? e(t) : e, ft = async (t, e, s) => {
  const [a, n, d, c] = await Promise.all([
    z(e, t.TOKEN),
    z(e, t.USERNAME),
    z(e, t.PASSWORD),
    z(e, t.HEADERS)
  ]), m = typeof (s == null ? void 0 : s.getHeaders) == "function" && (s == null ? void 0 : s.getHeaders()) || {}, E = Object.entries({
    Accept: "application/json",
    ...c,
    ...e.headers,
    ...m
  }).filter(([b, r]) => ie(r)).reduce((b, [r, I]) => ({
    ...b,
    [r]: String(I)
  }), {});
  if (te(a) && (E.Authorization = `Bearer ${a}`), te(n) && te(d)) {
    const b = ht(`${n}:${d}`);
    E.Authorization = `Basic ${b}`;
  }
  return e.body !== void 0 && (e.mediaType ? E["Content-Type"] = e.mediaType : xe(e.body) ? E["Content-Type"] = e.body.type || "application/octet-stream" : J(e.body) ? E["Content-Type"] = "text/plain" : ct(e.body) || (E["Content-Type"] = "application/json")), E;
}, vt = (t) => {
  if (t.body)
    return t.body;
}, yt = async (t, e, s, a, n, d, c, m) => {
  const E = Ae.CancelToken.source(), b = {
    url: s,
    headers: d,
    data: a ?? n,
    method: e.method,
    withCredentials: t.WITH_CREDENTIALS,
    withXSRFToken: t.CREDENTIALS === "include" ? t.WITH_CREDENTIALS : !1,
    cancelToken: E.token
  };
  c(() => E.cancel("The user aborted a request."));
  try {
    return await m.request(b);
  } catch (r) {
    const I = r;
    if (I.response)
      return I.response;
    throw r;
  }
}, bt = (t, e) => {
  if (e) {
    const s = t.headers[e];
    if (J(s))
      return s;
  }
}, Ct = (t) => {
  if (t.status !== 204)
    return t.data;
}, Et = (t, e) => {
  const s = {
    400: "Bad Request",
    401: "Unauthorized",
    403: "Forbidden",
    404: "Not Found",
    500: "Internal Server Error",
    502: "Bad Gateway",
    503: "Service Unavailable",
    ...t.errors
  }[e.status];
  if (s)
    throw new G(t, e, s);
  if (!e.ok) {
    const a = e.status ?? "unknown", n = e.statusText ?? "unknown", d = (() => {
      try {
        return JSON.stringify(e.body, null, 2);
      } catch {
        return;
      }
    })();
    throw new G(t, e, `Generic Error: status: ${a}; status text: ${n}; body: ${d}`);
  }
}, qt = (t, e, s = Ae) => new dt(async (a, n, d) => {
  try {
    const c = mt(t, e), m = gt(e), E = vt(e), b = await ft(t, e, m);
    if (!d.isCancelled) {
      const r = await yt(t, e, c, E, m, b, d, s), I = Ct(r), w = bt(r, e.responseHeader), x = {
        url: c,
        ok: ut(r.status),
        status: r.status,
        statusText: r.statusText,
        body: w ?? I
      };
      Et(e, x), a(x.body);
    }
  } catch (c) {
    n(c);
  }
});
class It extends it {
  constructor(e) {
    super(e);
  }
  /**
   * Request method
   * @param options The request options from the service
   * @returns CancelablePromise<T>
   * @throws ApiError
   */
  request(e) {
    return qt(this.config, e);
  }
}
class Tt {
  constructor(e) {
    u(this, "httpRequest"), this.httpRequest = e;
  }
  /**
   * @param activityId
   * @returns any OK
   * @throws ApiError
   */
  activitiesDelete(e) {
    return this.httpRequest.request({
      method: "DELETE",
      url: "/api/activities/{activityId}",
      path: {
        activityId: e
      }
    });
  }
  /**
   * @param carId
   * @returns ActivityGetDto OK
   * @throws ApiError
   */
  activitiesGetCarActivities(e) {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/cars/{carId}/activities",
      path: {
        carId: e
      }
    });
  }
  /**
   * @param dealerId
   * @param startDate
   * @param endDate
   * @returns ActivityGetDto OK
   * @throws ApiError
   */
  activitiesGetDealerActivitiesForPeriod(e, s, a) {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/dealers/{dealerId}/activities",
      path: {
        dealerId: e
      },
      query: {
        startDate: s,
        endDate: a
      }
    });
  }
  /**
   * @param userId
   * @param startDate
   * @param endDate
   * @returns ActivityGetDto OK
   * @throws ApiError
   */
  activitiesGetUserActivitiesForPeriod(e, s, a) {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/users/{userId}/activities",
      path: {
        userId: e
      },
      query: {
        startDate: s,
        endDate: a
      }
    });
  }
  /**
   * @param requestBody
   * @returns ActivityGetDto OK
   * @throws ApiError
   */
  activitiesPost(e) {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/activities",
      body: e,
      mediaType: "application/json-patch+json"
    });
  }
}
class kt {
  constructor(e) {
    u(this, "httpRequest"), this.httpRequest = e;
  }
  /**
   * @returns string OK
   * @throws ApiError
   */
  authRefreshToken() {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/auth/refreshtoken"
    });
  }
}
class wt {
  constructor(e) {
    u(this, "httpRequest"), this.httpRequest = e;
  }
  /**
   * @param keyword
   * @param searchBy
   * @param includeOutOfInventory
   * @param includeAllDealers
   * @returns any OK
   * @throws ApiError
   */
  carsGetFindResults(e, s, a, n) {
    return this.httpRequest.request({
      method: "GET",
      url: "/car/find/results",
      query: {
        SearchBy: s,
        Keyword: e,
        IncludeOutOfInventory: a,
        IncludeAllDealers: n
      }
    });
  }
  /**
   * @param manufacturerId
   * @returns string OK
   * @throws ApiError
   */
  carsGetBaseModels(e) {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/cars/basemodels/{manufacturerId}",
      path: {
        manufacturerId: e
      }
    });
  }
  /**
   * @param dealerId
   * @param stockNumber
   * @returns string OK
   * @throws ApiError
   */
  carsGetCarsWithStockNumberByDealer(e, s) {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/dealers/{dealerId}/cars/{stockNumber}",
      path: {
        dealerId: e,
        stockNumber: s
      }
    });
  }
  /**
   * @param dealerId
   * @param stockNumber
   * @returns CarStockNumberUsageDto OK
   * @throws ApiError
   */
  carsGetStockNumberUsage(e, s) {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/dealers/{dealerId}/stocknumbers/{stockNumber}",
      path: {
        dealerId: e,
        stockNumber: s
      }
    });
  }
  /**
   * @param dealerId
   * @param stockNumber
   * @returns boolean OK
   * @throws ApiError
   */
  carsGetStockNumberInUse(e, s) {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/dealers/{dealerId}/stocknumbers/{stockNumber}/inuse",
      path: {
        dealerId: e,
        stockNumber: s
      }
    });
  }
  /**
   * @param dealerId
   * @returns CarGetDto OK
   * @throws ApiError
   */
  carsGetCarsInInventoryByDealer(e) {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/dealers/{dealerId}/cars",
      path: {
        dealerId: e
      }
    });
  }
  /**
   * @param dealerId
   * @param vin
   * @returns CarGetDetailsDto OK
   * @throws ApiError
   */
  carsGetCarDetailsByDealer(e, s) {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/dealers/{dealerId}/cars/{vin}/details",
      path: {
        dealerId: e,
        vin: s
      }
    });
  }
  /**
   * @param manufacturerId
   * @param baseModel
   * @returns CarTrimsDto OK
   * @throws ApiError
   */
  carsGetTrims(e, s) {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/cars/trims/{manufacturerId}/{baseModel}",
      path: {
        manufacturerId: e,
        baseModel: s
      }
    });
  }
  /**
   * @param carId
   * @returns CarGetDto OK
   * @throws ApiError
   */
  carsGet(e) {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/cars/{carId}",
      path: {
        carId: e
      }
    });
  }
  /**
   * @param carId
   * @returns CarDeleteDto OK
   * @throws ApiError
   */
  carsDelete(e) {
    return this.httpRequest.request({
      method: "DELETE",
      url: "/api/cars/{carId}",
      path: {
        carId: e
      }
    });
  }
  /**
   * @param carId
   * @param requestBody
   * @returns CarGetDto OK
   * @throws ApiError
   */
  carsPatch(e, s) {
    return this.httpRequest.request({
      method: "PATCH",
      url: "/api/cars/{carId}",
      path: {
        carId: e
      },
      body: s,
      mediaType: "application/json-patch+json"
    });
  }
  /**
   * @param carId
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  carsPut(e, s) {
    return this.httpRequest.request({
      method: "PUT",
      url: "/api/cars/{carId}",
      path: {
        carId: e
      },
      body: s,
      mediaType: "application/json-patch+json"
    });
  }
  /**
   * @returns ColorGetDto OK
   * @throws ApiError
   */
  carsGetColorOptions() {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/cars/coloroptions"
    });
  }
  /**
   * @param carId
   * @returns boolean OK
   * @throws ApiError
   */
  carsHasOptions(e) {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/cars/hasoptions",
      query: {
        carId: e
      }
    });
  }
  /**
   * @param requestBody
   * @returns CarGetDto OK
   * @throws ApiError
   */
  carsPostFromDecodedData(e) {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/cars/fromdecodeddata",
      body: e,
      mediaType: "application/json-patch+json"
    });
  }
  /**
   * @param requestBody
   * @returns CarPostBasicResultDto OK
   * @throws ApiError
   */
  carsPostNew(e) {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/cars/new",
      body: e,
      mediaType: "application/json-patch+json"
    });
  }
  /**
   * @param carId
   * @param vehicleId
   * @param transmission
   * @returns TryOptionsUpdateResultDto OK
   * @throws ApiError
   */
  carsTryUpdateOptionsFromDataOne(e, s, a) {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/cars/tryupdateoptionsfromdatatone/{carId}",
      path: {
        carId: e
      },
      query: {
        vehicleId: s,
        transmission: a
      }
    });
  }
  /**
   * Re-adds a car to inventory optionally changing its stock number
   * @param carId
   * @param stockNumber
   * @returns any OK
   * @throws ApiError
   */
  carsReAddToInventory(e, s) {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/cars/readdtoinventory/{carId}",
      path: {
        carId: e
      },
      query: {
        stockNumber: s
      }
    });
  }
  /**
   * Restores a car to inventory
   * Restores a car to inventory using its VIN and stock number
   * @param vin
   * @param stockNumber
   * @returns CarGetDto OK
   * @throws ApiError
   */
  carsRestoreToInventory(e, s) {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/cars/restoretoinventory/{vin}",
      path: {
        vin: e
      },
      query: {
        stockNumber: s
      }
    });
  }
  /**
   * @param carId
   * @returns any OK
   * @throws ApiError
   */
  carsRemoveFromInventory(e) {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/cars/removefrominventory/{carId}",
      path: {
        carId: e
      }
    });
  }
  /**
   * @param carId
   * @returns any OK
   * @throws ApiError
   */
  carsRegenerateVideo(e) {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/cars/regeneratevideo/{carId}",
      path: {
        carId: e
      }
    });
  }
  /**
   * @param carId
   * @returns string OK
   * @throws ApiError
   */
  carsDeleteVideo(e) {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/cars/deletevideo/{carId}",
      path: {
        carId: e
      }
    });
  }
}
class St {
  constructor(e) {
    u(this, "httpRequest"), this.httpRequest = e;
  }
  /**
   * @param vin
   * @returns DataOneDecodeResponseDto OK
   * @throws ApiError
   */
  dataOneDecodeGet(e) {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/dataone/decode",
      query: {
        vin: e
      }
    });
  }
  /**
   * @param vin
   * @returns DataOneDecodeResponseDto OK
   * @throws ApiError
   */
  dataOneDecodePost(e) {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/dataone/decode",
      query: {
        vin: e
      }
    });
  }
}
class Rt {
  constructor(e) {
    u(this, "httpRequest"), this.httpRequest = e;
  }
  /**
   * @param dealerId
   * @returns DealerGetDto OK
   * @throws ApiError
   */
  dealersGet(e) {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/dealers/{dealerId}",
      path: {
        dealerId: e
      }
    });
  }
  /**
   * @param dealerId
   * @returns DealerCarMediaCopyMatchesPostResponseDto OK
   * @throws ApiError
   */
  dealersGetCarMediaCopyMatches(e) {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/dealers/{dealerId}/cars/mediacopymatches",
      path: {
        dealerId: e
      }
    });
  }
  /**
   * @param dealerId
   * @returns DealerGetMediaManagerSettingsDto OK
   * @throws ApiError
   */
  dealersGetMediaManagerSettings(e) {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/dealers/{dealerId}/mediamanagersettings",
      path: {
        dealerId: e
      }
    });
  }
  /**
   * @param dealerId
   * @returns DealerGetServiceRateDto OK
   * @throws ApiError
   */
  dealersGetServiceRates(e) {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/dealers/{dealerId}/servicerates",
      path: {
        dealerId: e
      }
    });
  }
  /**
   * @param dealerId
   * @returns DealerGetStickerTypeDto OK
   * @throws ApiError
   */
  dealersGetStickerTypes(e) {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/dealers/{dealerId}/stickertypes",
      path: {
        dealerId: e
      }
    });
  }
  /**
   * @param dealerId
   * @param requestBody
   * @returns string OK
   * @throws ApiError
   */
  dealersPostCarClone(e, s) {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/dealers/{dealerId}/cars/clone",
      path: {
        dealerId: e
      },
      body: s,
      mediaType: "application/json-patch+json"
    });
  }
}
class Nt {
  constructor(e) {
    u(this, "httpRequest"), this.httpRequest = e;
  }
  /**
   * @param userId
   * @param dealerId
   * @returns MediaCopierSettingsGetDto OK
   * @throws ApiError
   */
  mediaCopierSettingsGet(e, s) {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/mediacopiersettings",
      query: {
        userId: e,
        dealerId: s
      }
    });
  }
  /**
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  mediaCopierSettingsPatch(e) {
    return this.httpRequest.request({
      method: "PATCH",
      url: "/api/mediacopiersettings",
      body: e,
      mediaType: "application/json-patch+json"
    });
  }
}
class At {
  constructor(e) {
    u(this, "httpRequest"), this.httpRequest = e;
  }
  /**
   * @returns MediaUploadSetWithUnassignedMediaDto OK
   * @throws ApiError
   */
  mediaUploadGetUserUploadsWithUnassignedMedia() {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/mediaupload/currentuserswithunassignedmedia"
    });
  }
  /**
   * @param requestBody
   * @returns MediaUploadSetDto OK
   * @throws ApiError
   */
  mediaUploadPost(e) {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/mediaupload",
      body: e,
      mediaType: "application/json-patch+json"
    });
  }
  /**
   * @param requestBody
   * @returns MediaUploadSetDto OK
   * @throws ApiError
   */
  mediaUploadPut(e) {
    return this.httpRequest.request({
      method: "PUT",
      url: "/api/mediaupload",
      body: e,
      mediaType: "application/json-patch+json"
    });
  }
  /**
   * Warning: Id in route and S3Path in dto are unused but preserved for consistency.
   * @param uploadSetId
   * @returns any OK
   * @throws ApiError
   */
  mediaUploadSortItems(e) {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/mediaupload/{uploadSetId}/sortitems",
      path: {
        uploadSetId: e
      }
    });
  }
  /**
   * @param uploadSetId
   * @returns MediaUploadItemResponseDto OK
   * @throws ApiError
   */
  mediaUploadUnassignedItems(e) {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/mediaupload/{uploadSetId}/unassigneditems",
      path: {
        uploadSetId: e
      }
    });
  }
}
class $t {
  constructor(e) {
    u(this, "httpRequest"), this.httpRequest = e;
  }
  /**
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  mediaUploadItemBatchDelete(e) {
    return this.httpRequest.request({
      method: "DELETE",
      url: "/api/mediauploaditem/batch",
      body: e,
      mediaType: "application/json-patch+json"
    });
  }
  /**
   * @param id
   * @returns any OK
   * @throws ApiError
   */
  mediaUploadItemDelete(e) {
    return this.httpRequest.request({
      method: "DELETE",
      url: "/api/mediauploaditem/{id}",
      path: {
        id: e
      }
    });
  }
  /**
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  mediaUploadItemDeleteAlternate(e) {
    return this.httpRequest.request({
      method: "DELETE",
      url: "/api/mediauploaditem/delete",
      body: e,
      mediaType: "application/json-patch+json"
    });
  }
  /**
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  mediaUploadItemDeleteAlternatePost(e) {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/mediauploaditem/delete",
      body: e,
      mediaType: "application/json-patch+json"
    });
  }
  /**
   * @param formData
   * @returns any OK
   * @throws ApiError
   */
  mediaUploadItemPost(e) {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/mediauploaditem",
      formData: e,
      mediaType: "multipart/form-data"
    });
  }
  /**
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  mediaUploadItemPreflightUpload(e) {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/mediauploaditem/preflightupload",
      body: e,
      mediaType: "application/json-patch+json"
    });
  }
}
class Dt {
  constructor(e) {
    u(this, "httpRequest"), this.httpRequest = e;
  }
  /**
   * @returns CarNotShotReasonDto OK
   * @throws ApiError
   */
  notShotGetNotShotReasons() {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/notshot/reasons"
    });
  }
  /**
   * @param dealerId
   * @returns CarNotShotGetDto OK
   * @throws ApiError
   */
  notShotGetDealerNotShots(e) {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/dealers/{dealerId}/notshots",
      path: {
        dealerId: e
      }
    });
  }
  /**
   * @param carId
   * @returns CarNotShotGetDto OK
   * @throws ApiError
   */
  notShotGet(e) {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/notshot/{carId}",
      path: {
        carId: e
      }
    });
  }
  /**
   * @param carId
   * @param requestBody
   * @returns CarNotShotPutDto OK
   * @throws ApiError
   */
  notShotPut(e, s) {
    return this.httpRequest.request({
      method: "PUT",
      url: "/api/notshot/{carId}",
      path: {
        carId: e
      },
      body: s,
      mediaType: "application/json-patch+json"
    });
  }
  /**
   * @param requestBody
   * @returns CarNotShotPutDto OK
   * @throws ApiError
   */
  notShotPatch(e) {
    return this.httpRequest.request({
      method: "PATCH",
      url: "/api/notshot",
      body: e,
      mediaType: "application/json-patch+json"
    });
  }
}
class Ot {
  constructor(e) {
    u(this, "httpRequest"), this.httpRequest = e;
  }
  /**
   * @param carId
   * @returns CarOptionGetDto OK
   * @throws ApiError
   */
  optionsGetCarOptions(e) {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/cars/{carId}/options",
      path: {
        carId: e
      }
    });
  }
  /**
   * @param carId
   * @returns number OK
   * @throws ApiError
   */
  optionsClearCarOptions(e) {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/cars/{carId}/options/clear",
      path: {
        carId: e
      }
    });
  }
}
class xt {
  constructor(e) {
    u(this, "httpRequest"), this.httpRequest = e;
  }
  /**
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  paperTrailAlert(e) {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/papertrail/alert",
      body: e,
      mediaType: "application/json-patch+json"
    });
  }
  /**
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  paperTrailCritical(e) {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/papertrail/critical",
      body: e,
      mediaType: "application/json-patch+json"
    });
  }
  /**
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  paperTrailDebug(e) {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/papertrail/debug",
      body: e,
      mediaType: "application/json-patch+json"
    });
  }
  /**
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  paperTrailError(e) {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/papertrail/error",
      body: e,
      mediaType: "application/json-patch+json"
    });
  }
  /**
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  paperTrailInfo(e) {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/papertrail/info",
      body: e,
      mediaType: "application/json-patch+json"
    });
  }
  /**
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  paperTrailLog(e) {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/papertrail/log",
      body: e,
      mediaType: "application/json-patch+json"
    });
  }
  /**
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  paperTrailWarn(e) {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/papertrail/warn",
      body: e,
      mediaType: "application/json-patch+json"
    });
  }
}
class Vt {
  constructor(e) {
    u(this, "httpRequest"), this.httpRequest = e;
  }
  /**
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  photosBatch(e) {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/photos/batch",
      body: e,
      mediaType: "application/json-patch+json"
    });
  }
  /**
   * @param photoId
   * @returns PhotoGetDto OK
   * @throws ApiError
   */
  photosGet(e) {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/photos/{photoId}",
      path: {
        photoId: e
      }
    });
  }
  /**
   * @param carId
   * @returns PhotoDto OK
   * @throws ApiError
   */
  photosGetPhotosByCarId(e) {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/cars/{carId}/photos",
      path: {
        carId: e
      }
    });
  }
  /**
   * @param carId
   * @returns PhotoDto OK
   * @throws ApiError
   */
  photosGetUserPhotosByCarId(e) {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/cars/{carId}/photos/currentusers",
      path: {
        carId: e
      }
    });
  }
}
class Gt {
  constructor(e) {
    u(this, "httpRequest"), this.httpRequest = e;
  }
  /**
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  stagedActivitiesBatchToActivities(e) {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/stagedactivities/batchtoactivities",
      body: e,
      mediaType: "application/json-patch+json"
    });
  }
  /**
   * @param stagedActivityId
   * @returns any OK
   * @throws ApiError
   */
  stagedActivitiesDelete(e) {
    return this.httpRequest.request({
      method: "DELETE",
      url: "/api/stagedactivities/{stagedActivityId}",
      path: {
        stagedActivityId: e
      }
    });
  }
  /**
   * @param stagedActivityId
   * @param requestBody
   * @returns StagedActivityGetDto OK
   * @throws ApiError
   */
  stagedActivitiesPatch(e, s) {
    return this.httpRequest.request({
      method: "PATCH",
      url: "/api/stagedactivities/{stagedActivityId}",
      path: {
        stagedActivityId: e
      },
      body: s,
      mediaType: "application/json-patch+json"
    });
  }
  /**
   * @param stagedActivityId
   * @param requestBody
   * @returns StagedActivityGetDto OK
   * @throws ApiError
   */
  stagedActivitiesPut(e, s) {
    return this.httpRequest.request({
      method: "PUT",
      url: "/api/stagedactivities/{stagedActivityId}",
      path: {
        stagedActivityId: e
      },
      body: s,
      mediaType: "application/json-patch+json"
    });
  }
  /**
   * @param carId
   * @returns StagedActivityGetDto OK
   * @throws ApiError
   */
  stagedActivitiesGetCarStagedActivities(e) {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/cars/{carId}/stagedactivities",
      path: {
        carId: e
      }
    });
  }
  /**
   * @param dealerId
   * @returns StagedActivityGetDto OK
   * @throws ApiError
   */
  stagedActivitiesGetDealersStagedActivities(e) {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/dealers/{dealerId}/stagedactivities",
      path: {
        dealerId: e
      }
    });
  }
  /**
   * @param requestBody
   * @returns StagedActivityGetDto OK
   * @throws ApiError
   */
  stagedActivitiesPost(e) {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/stagedactivities",
      body: e,
      mediaType: "application/json-patch+json"
    });
  }
}
class Bt {
  constructor(e) {
    u(this, "httpRequest"), this.httpRequest = e;
  }
  /**
   * @param dealerName
   * @param stockNumber
   * @returns any OK
   * @throws ApiError
   */
  vehicleVideoVideoDeletedEvent(e, s) {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/vehiclevideo/deleted/{dealerName}/{stockNumber}",
      path: {
        dealerName: e,
        stockNumber: s
      }
    });
  }
  /**
   * @param dealerName
   * @param stockNumber
   * @param s3FileUrl
   * @returns any OK
   * @throws ApiError
   */
  vehicleVideoVideoUploadedEvent(e, s, a) {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/vehiclevideo/uploaded/{dealerName}/{stockNumber}/{s3FileUrl}",
      path: {
        dealerName: e,
        stockNumber: s,
        s3FileUrl: a
      }
    });
  }
}
class Ut {
  constructor(e) {
    u(this, "httpRequest"), this.httpRequest = e;
  }
  /**
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  videosBatch(e) {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/videos/batch",
      body: e,
      mediaType: "application/json-patch+json"
    });
  }
  /**
   * @param videoId
   * @returns CarVideoGetDto OK
   * @throws ApiError
   */
  videosGet(e) {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/videos/{videoId}",
      path: {
        videoId: e
      }
    });
  }
  /**
   * @param carId
   * @returns VideoDto OK
   * @throws ApiError
   */
  videosGetVideosByCarId(e) {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/cars/{carId}/videos",
      path: {
        carId: e
      }
    });
  }
  /**
   * @param carId
   * @returns VideoDto OK
   * @throws ApiError
   */
  videosGetUserVideosByCarId(e) {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/cars/{carId}/videos/currentusers",
      path: {
        carId: e
      }
    });
  }
}
class Pt {
  constructor(e, s = It) {
    u(this, "activitiesEndpoints"), u(this, "authEndpoints"), u(this, "carsEndpoints"), u(this, "dataOneEndpoints"), u(this, "dealersEndpoints"), u(this, "mediaCopierSettingsEndpoints"), u(this, "mediaUploadEndpoints"), u(this, "mediaUploadItemEndpoints"), u(this, "notShotEndpoints"), u(this, "optionsEndpoints"), u(this, "paperTrailEndpoints"), u(this, "photoEndpoints"), u(this, "stagedActivitiesEndpoints"), u(this, "vehicleVideoEndpoints"), u(this, "videoEndpoints"), u(this, "request"), this.request = new s({
      BASE: (e == null ? void 0 : e.BASE) ?? "",
      VERSION: (e == null ? void 0 : e.VERSION) ?? "1",
      WITH_CREDENTIALS: (e == null ? void 0 : e.WITH_CREDENTIALS) ?? !1,
      CREDENTIALS: (e == null ? void 0 : e.CREDENTIALS) ?? "include",
      TOKEN: e == null ? void 0 : e.TOKEN,
      USERNAME: e == null ? void 0 : e.USERNAME,
      PASSWORD: e == null ? void 0 : e.PASSWORD,
      HEADERS: e == null ? void 0 : e.HEADERS,
      ENCODE_PATH: e == null ? void 0 : e.ENCODE_PATH
    }), this.activitiesEndpoints = new Tt(this.request), this.authEndpoints = new kt(this.request), this.carsEndpoints = new wt(this.request), this.dataOneEndpoints = new St(this.request), this.dealersEndpoints = new Rt(this.request), this.mediaCopierSettingsEndpoints = new Nt(this.request), this.mediaUploadEndpoints = new At(this.request), this.mediaUploadItemEndpoints = new $t(this.request), this.notShotEndpoints = new Dt(this.request), this.optionsEndpoints = new Ot(this.request), this.paperTrailEndpoints = new xt(this.request), this.photoEndpoints = new Vt(this.request), this.stagedActivitiesEndpoints = new Gt(this.request), this.vehicleVideoEndpoints = new Bt(this.request), this.videoEndpoints = new Ut(this.request);
  }
}
var M;
(function(t) {
  t.FAILED = "Failed", t.CAR_ADDED = "CarAdded", t.CAR_RESTORED = "CarRestored", t.CAR_EXISTED = "CarExisted";
})(M || (M = {}));
var Se;
(function(t) {
  t.PHOTO = "Photo", t.VIDEO = "Video", t.AUDIO = "Audio";
})(Se || (Se = {}));
let v;
function N(t) {
  return new Pt({
    BASE: t,
    HEADERS: {
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest"
      // tell WebAPI not to redirect on auth issues
    },
    CREDENTIALS: "include",
    WITH_CREDENTIALS: !0
  });
}
function _t(t) {
  v = N(t);
}
const V = {
  carsGetCarDetailsByDealer(t, e) {
    return v === void 0 && (v = N("")), console.log(`[api-call] Checking for existing vin ${e} and dealer ${t}}`), v.carsEndpoints.carsGetCarDetailsByDealer(t, e);
  },
  decodeVin(t) {
    return v === void 0 && (v = N("")), console.log(`[api-call] Decoding vin ${t}`), v.dataOneEndpoints.dataOneDecodeGet(t);
  },
  //api/cars/tryupdateoptionsfromdatatone"
  updateOptions(t, e, s) {
    return v === void 0 && (v = N("")), console.log(`[api-call]  Updating options for car ${t} with vehicleId ${e} and transmission ${s}`), v.carsEndpoints.carsTryUpdateOptionsFromDataOne(t, e, s);
  },
  addCar(t, e, s, a) {
    return v === void 0 && (v = N("")), v.carsEndpoints.carsPostFromDecodedData({
      carVin: t,
      carStockNumber: e,
      vehicleId: s,
      transmissionName: a
    });
  },
  addCarBasic(t, e) {
    return v === void 0 && (v = N("")), v.carsEndpoints.carsPostNew({
      carVin: t,
      carStockNumber: e
    });
  },
  getStockNumberInUse(t, e) {
    return v === void 0 && (v = N("")), v.carsEndpoints.carsGetStockNumberInUse(t, e);
  },
  /*
      getStockNumberUsage(dealerId:number,stockNumber: string): CancelablePromise<CarStockNumberUsageDto[]> {
          if (FS_CLIENT === undefined) FS_CLIENT = createFieldServiceClient("");
  
          return FS_CLIENT.carsEndpoints.carsGetStockNumberUsage(dealerId, stockNumber);
      },*/
  getCarById(t) {
    return v === void 0 && (v = N("")), v.carsEndpoints.carsGet(t);
  },
  restoreCar(t) {
    return v === void 0 && (v = N("")), v.carsEndpoints.carsReAddToInventory(t);
  },
  restoreCarByVin(t, e) {
    return v === void 0 && (v = N("")), v.carsEndpoints.carsRestoreToInventory(t, e);
  }
}, jt = { id: "car-setup-wrapper" }, Ft = /* @__PURE__ */ X({
  __name: "App",
  setup(t) {
    return (e, s) => (h(), p("div", jt, [
      ae(o(st), { "transition-attrs": { name: "dialog" } })
    ]));
  }
});
var U;
(function(t) {
  t.AddingCar = "AddingCar", t.UpdatingOptions = "UpdatingOptions";
})(U || (U = {}));
var k;
(function(t) {
  t.Forward = "Forward", t.Backward = "Backward";
})(k || (k = {}));
var l;
(function(t) {
  t.Initial = "Initial", t.CallingUpdate = "CallingUpdate", t.SelectTrim = "SelectTrim", t.SelectTransmission = "SelectTransmission", t.CallingUpdateAgain = "CallingUpdateAgain", t.Finished = "Finished", t.Error = "Error", t.CheckForExisting = "CheckForExisting", t.CarAlreadyExists = "CarAlreadyExists", t.CallingRestoreCar = "CallingRestoreCar", t.RequestBasics = "RequestBasics", t.CallingDecode = "CallingDecode", t.ConfirmDetails = "ConfirmDetails", t.ConfirmedDetails = "ConfirmedDetails", t.CallingAddCar = "CallingAddCar", t.GoingBack = "GoingBack", t.Continuing = "Continuing";
})(l || (l = {}));
var A;
(function(t) {
  t.Unknown = "Unknown", t.CarExists = "CarExists", t.CarDoesNotExist = "CarDoesNotExist";
})(A || (A = {}));
var O;
(function(t) {
  t.Cancelled = "Cancelled", t.CarAdded = "CarAdded", t.CarRestored = "CarRestored", t.CarAlreadyExists = "CarAlreadyExists";
})(O || (O = {}));
var K;
(function(t) {
  t.Recoverable = "Recoverable", t.Fatal = "Fatal";
})(K || (K = {}));
class Mt {
  constructor(e, s = K.Fatal) {
    L(this, "message");
    L(this, "level");
    L(this, "exception", null);
    this.message = e, this.level = s;
  }
}
const oe = Xe({
  id: "car-setup-state",
  state: () => ({
    /* Inputs */
    carId: "",
    carVin: "",
    carStockNumber: "",
    dealerId: 0,
    type: U.UpdatingOptions,
    allowDataOne: void 0,
    /* Validation */
    carVinValid: void 0,
    carStockNumberValid: void 0,
    carStockNumberExists: void 0,
    /* Lookups */
    vehicleId: "",
    transmissionId: "",
    existingCar: void 0,
    carExistence: A.Unknown,
    vehicle: void 0,
    transmission: void 0,
    carToAdd: void 0,
    styles: [],
    /* Results */
    optionsUpdated: 0,
    addedCar: void 0,
    restoredCar: void 0,
    /* Command States */
    showBack: !1,
    showContinue: !1,
    showCancel: !1,
    showOk: !1,
    /* States */
    dialogTitle: void 0,
    requestedNavigation: void 0,
    step: l.Initial,
    stepHistory: [],
    error: null,
    done: !1,
    initialized: !1
  }),
  getters: {
    // Internal state
    getFirstStep(t) {
      return t.stepHistory.length > 1 ? t.stepHistory[1] : t.step;
    },
    // Car related state
    getStyles(t) {
      return t.styles;
    },
    getTransmissions(t) {
      return t.styles.reduce(function(s, a) {
        return a.vehicleId == t.vehicleId && a.transmissions ? s.concat(a.transmissions) : s;
      }, new Array());
    },
    getVehicleDetails(t) {
      var n;
      const e = t.styles.find((d) => d.vehicleId == t.vehicleId);
      if (e == null)
        return null;
      const s = (n = e.transmissions) == null ? void 0 : n.find((d) => d.transmissionId == t.transmissionId);
      if (s == null)
        return null;
      const a = { ...e };
      return a.transmissions = [s], a;
    },
    hasVehicleId(t) {
      return t.vehicleId != "";
    },
    hasTransmissionId(t) {
      return t.transmissionId != "";
    },
    hasValidVinAndStockNumber(t) {
      return (t.carVinValid ?? !1) && (t.carStockNumberValid ?? !1);
    }
  },
  actions: {
    // Initializes the store, primarily to ensure if the
    // same store is used twice it will reset to empty
    // when another setup process begins.
    initialize(t) {
      console.log("[state-store] intiailizing with type ", t), this.$state.initialized && this.$reset(), this.$state.type = t, this.$state.initialized = !0;
    },
    setDialogTitle(t) {
      console.log("[state-store] setting dialog title ", t), this.$state.dialogTitle = t;
    },
    setStep(t) {
      console.log("[state-store] setting step ", t), this.$patch((e) => {
        e.stepHistory.push(e.step), e.step = t;
      });
    },
    requestNavigate(t) {
      console.log("[state-store] requesting navigation ", t), this.$state.requestedNavigation = t;
    },
    clearNavigation() {
      console.log("[state-store] clearing navigation ", this.$state.requestedNavigation), this.$state.requestedNavigation = void 0;
    },
    setError(t, e = K.Fatal) {
      this.$state.error = new Mt(t, e);
    },
    resetNavigationControls() {
      console.log("[state-store] resetting navigation controls "), this.$patch({
        showBack: !1,
        showContinue: !1,
        showOk: !1,
        showCancel: !1
      });
    },
    // General setters
    setTransmission(t) {
      console.log("[state-store] Setting transmission"), this.$patch({
        transmission: t,
        transmissionId: t.transmissionId ?? ""
      });
    },
    // Clear trim and transmission selections
    clearDecodedData() {
      this.$patch({
        vehicle: void 0,
        vehicleId: "",
        transmission: void 0,
        transmissionId: "",
        styles: []
      });
    },
    async validateVinAndStockNumber() {
      var t, e;
      this.$state.carVinValid = ((e = (t = this.carVin) == null ? void 0 : t.trim()) == null ? void 0 : e.length) == 17, await this.validateStockNumber();
    },
    async validateStockNumber() {
      var e, s;
      if (((s = (e = this.carStockNumber) == null ? void 0 : e.trim()) == null ? void 0 : s.length) <= 3) {
        this.$state.carStockNumberExists = !1, this.$state.carStockNumberValid = !1;
        return;
      }
      if (console.log("Calling api to test usage"), await V.getStockNumberInUse(this.$state.dealerId, this.$state.carStockNumber) == !0) {
        this.$state.carStockNumberExists = !0, this.$state.carStockNumberValid = !1;
        return;
      } else
        this.$state.carStockNumberExists = !1, this.$state.carStockNumberValid = !0;
    },
    // Api Calls
    async checkForExistingVin() {
      try {
        console.log("[state-store] calling carsGetCarDetailsByDealer api");
        const t = await V.carsGetCarDetailsByDealer(this.$state.dealerId, this.$state.carVin);
        console.log("[state-store] processing carsGetCarDetailsByDealer response"), this.$patch({
          existingCar: t,
          carExistence: t ? A.CarExists : A.CarDoesNotExist
        }), console.log("[state-store] updated existing car to", t);
      } catch (t) {
        if (t instanceof G)
          return this.handleApiError(t);
        this.setError("Encountered a problem, technical support notified.");
      }
    },
    clearExistingCar() {
      console.log("[state-store] Clearing existingCar"), this.$patch({
        existingCar: void 0,
        carExistence: A.Unknown
      });
    },
    // Returns true if we have shown that step before
    haveShownStep(t) {
      return this.$state.stepHistory.includes(t);
    },
    async decodeVin() {
      try {
        this.clearDecodedData(), console.log("[state-store] calling decodeVin api");
        const t = await V.decodeVin(this.$state.carVin);
        console.log("[state-store] processing decodeVin response"), this.$patch({ styles: t.styles ?? [] }), (t.styles == null || t.styles.length == 0) && this.setError(`No data returned for vin ${this.$state.carVin}.`);
      } catch (t) {
        if (t instanceof G)
          return this.handleApiError(t);
        this.setError("Encountered a problem, technical support notified.");
      }
    },
    async updateOptions() {
      var t, e;
      try {
        console.log("[state-store] calling update options api");
        const s = await V.updateOptions(this.$state.carId, this.$state.vehicleId ?? "", ((t = this.$state.transmission) == null ? void 0 : t.transmissionName) ?? "");
        if (console.log("[state-store] processing update options response"), s.updatedOptionsCount && s.updatedOptionsCount > 0) {
          this.$state.optionsUpdated = s.updatedOptionsCount, console.log("[state-store] updated option count");
          return;
        }
        if ((e = s == null ? void 0 : s.trimSelectionResponse) != null && e.styles) {
          this.$patch({
            styles: s.trimSelectionResponse.styles ?? []
          }), console.log("[state-store] updated styles");
          return;
        }
        this.setError("No styles or options returned for car.");
      } catch (s) {
        if (s instanceof G)
          return this.handleApiError(s);
        this.setError("Encountered a problem with that VIN.");
      }
    },
    async addCar() {
      var t;
      try {
        if (console.log("[state-store] calling add car api"), this.$state.transmission == null)
          throw new Error("No transmission found");
        const e = await V.addCar(this.$state.carVin, this.$state.carStockNumber, this.$state.vehicleId ?? "", ((t = this.$state.transmission) == null ? void 0 : t.transmissionName) ?? "");
        if (console.log("[state-store] processing add car response"), e) {
          this.$patch({ addedCar: e }), console.log("[state-store] added car and stored result");
          return;
        }
        this.setError(`No data returned when adding car with vin ${this.$state.carVin}.`);
      } catch (e) {
        if (e instanceof G)
          return this.handleApiError(e);
        console.error(e), this.setError("Encountered a problem, technical support notified.");
      }
    },
    async addCarWithoutDataOne() {
      try {
        console.log("[state-store] calling add car api without dataone");
        const e = await V.addCarBasic(this.$state.carVin, this.$state.carStockNumber);
        if (console.log("[state-store] processing add car basic response"), e.carId && e.result && e.result != M.FAILED) {
          var t = await V.getCarById(e.carId);
          if (t) {
            if (e.result == M.CAR_ADDED) {
              this.$patch({
                addedCar: t,
                addedCarResult: O.CarAdded
              }), console.log("[state-store] added car and stored result");
              return;
            } else if (e.result == M.CAR_RESTORED) {
              this.$patch({
                restoredCar: t,
                addedCarResult: O.CarRestored
              }), console.log("[state-store] restored car and stored result");
              return;
            } else if (e.result == M.CAR_EXISTED) {
              this.$patch({
                existingCar: t,
                addedCarResult: O.CarAlreadyExists
              }), console.log("[state-store] found existing car and stored result");
              return;
            }
          } else
            this.setError(`Car with id ${e.carId} added but not returned.`);
        } else
          this.setError(`Car with vin ${this.$state.carVin} could not be added.`);
      } catch (e) {
        if (e instanceof G)
          return this.handleApiError(e);
        console.error(e), this.setError("Encountered a problem, technical support notified.");
      }
    },
    async restoreCarToInventory() {
      var e, s, a;
      try {
        if (console.log(`[state-store] calling restore car api (${(e = this.$state.existingCar) == null ? void 0 : e.carVin}, ${this.$state.carStockNumber})`), !((s = this.$state.existingCar) != null && s.carVin))
          throw new Error("No VIN found for the existing car");
        var t = await V.restoreCarByVin(this.$state.existingCar.carVin, this.$state.carStockNumber);
        return console.log(`[state-store] restored car ${(a = this.$state.existingCar) == null ? void 0 : a.carVin} to inventory`), this.$patch({ restoredCar: t }), !0;
      } catch (n) {
        return n instanceof G ? this.handleApiError(n) : (console.error(n), this.setError("Encountered a problem, technical support notified."), !1);
      }
    },
    handleApiError(t) {
      console.log("handleApiError - " + t);
      const e = this.readErrorBody(t);
      switch (t.status) {
        case 400:
          this.setError(e);
          return;
        case 401:
          this.setError("User is unathenticated");
          return;
        case 409:
          this.setError(e);
          return;
        default:
          this.setError(e);
          return;
      }
    },
    cleanupErrorBodyMessage(t) {
      return t.indexOf("Invalid VIN") > -1 ? "That VIN appears invalid" : t.length > 512 ? t.indexOf("<html") > -1 ? "Server experienced an error processing your request" : t.substring(0, 512) : t;
    },
    readErrorBody(t) {
      var d, c, m, E, b, r;
      if ((d = t == null ? void 0 : t.body) != null && d.detail && ((m = (c = t == null ? void 0 : t.body) == null ? void 0 : c.detail) == null ? void 0 : m.length) > 0)
        return t.body.detail;
      let e = [];
      if (t.body) {
        if (Array.isArray(t.body)) {
          if (t.body.length > 0 && ((E = t.body[0].message) == null ? void 0 : E.length) > 0)
            return this.cleanupErrorBodyMessage(t.body[0].message);
        } else if (t.body[""] && Array.isArray(t.body[""]) && t.body[""].length > 0)
          return this.cleanupErrorBodyMessage(t.body[""][0]);
      }
      if (t.message && t.message != "Generic Error" && e.push(t.message), t.statusText && e.push(t.statusText), (r = (b = t.body) == null ? void 0 : b.data) != null && r.error && e.push(t.body.data.error), t.body)
        if (Array.isArray(t.body)) {
          let I = t.body;
          for (var s in I)
            if (s !== "data") {
              console.log(s), console.log(I[s]);
              var a = I[s];
              s == "" ? e.push(a) : e.push(`${s} : ${a}`);
            }
        } else
          e.push(t.body);
      return e.join(`\r
`);
    }
  }
}), Ht = (t) => {
  re(async () => {
    console.log("[state-machine] initializing.");
    const e = oe();
    e.initialize(U.UpdatingOptions), e.carId = t.carId, C(() => e.step, async (s, a) => {
      switch (console.log(`[state-machine] Step ${a} -> ${s}`), e.showCancel = !1, e.showOk = !1, e.showBack = !1, e.showContinue = !1, s) {
        case l.SelectTrim:
          e.showCancel = !0, e.showContinue = e.vehicle != null;
          break;
        case l.SelectTransmission:
          e.showCancel = !0, e.showBack = !0;
          break;
        case l.CallingUpdate:
          e.showCancel = !0, e.showOk = !1;
          break;
        case l.Finished:
          e.showCancel = !1, e.showOk = !0;
          break;
        case l.Error:
          e.showOk = !1, e.showCancel = !0;
          break;
      }
    }), C(() => e.requestedNavigation, async (s) => {
      if (s != null) {
        switch (console.log(`[state-machine] Requested Navigation ${s}`), e.step) {
          case l.SelectTrim:
            s == k.Forward && e.setStep(l.SelectTransmission);
            break;
          case l.SelectTransmission:
            s == k.Backward && e.setStep(l.SelectTrim);
            break;
        }
        e.clearNavigation();
      }
    }), C(() => e.styles, (s, a) => {
      switch (console.log(`[state-machine] Styles ${a} -> ${s}`), s.length) {
        case 0:
          e.setError("No styles returned from DataOne");
          break;
        case 1:
          e.vehicleId = s[0].vehicleId ?? "";
          break;
        default:
          e.setStep(l.SelectTrim);
          break;
      }
    }), C(() => e.vehicle, (s, a) => {
      var d;
      console.log(`[state-machine] Vehicle ${a} -> ${s}`);
      const n = (d = e.vehicle) == null ? void 0 : d.transmissions;
      if (n)
        switch (n.length) {
          case 0:
            e.setError("No transmissions returned from DataOne");
            break;
          case 1:
            e.setTransmission(n[0]);
            break;
          default:
            e.setStep(l.SelectTransmission);
            break;
        }
    }), C(() => e.vehicleId, (s, a) => {
      const n = e.styles.find((d) => d.vehicleId == e.vehicleId);
      e.$patch({ vehicle: n });
    }), C(() => e.transmission, async (s, a) => {
      console.log(`[state-machine] Transmission ${a} -> ${s}`), !(e.vehicle === void 0 || e.transmission === void 0) && (e.setStep(l.CallingUpdateAgain), await e.updateOptions());
    }), C(() => e.transmissionId, (s, a) => {
      var d, c;
      const n = (c = (d = e.vehicle) == null ? void 0 : d.transmissions) == null ? void 0 : c.find((m) => m.transmissionId == e.transmissionId);
      e.$patch({ transmission: n });
    }), C(() => e.optionsUpdated, (s, a) => {
      console.log(`[state-machine] OptionsUpdated ${a} -> ${s}`), e.setStep(l.Finished), t.closeOnUpdate && (e.done = !0);
    }), C(() => e.error, (s, a) => {
      console.log(`[state-machine] Error ${a} -> ${s}`), e.setStep(l.Error);
    }), console.log("[state-machine] update-options mounted."), e.setDialogTitle("Update Options"), e.setStep(l.CallingUpdate), await e.updateOptions();
  });
}, Wt = (t) => {
  re(async () => {
    const e = oe();
    e.initialize(U.AddingCar), e.carVin = t.carVin, e.dealerId = t.dealerId, e.allowDataOne = t.allowDataOne ?? !0, C(() => e.requestedNavigation, async (s) => {
      var a;
      if (s != null) {
        switch (console.log(`[state-machine] Requested Navigation ${s}`), e.step) {
          case l.RequestBasics:
            if (s == k.Forward)
              if (await e.validateVinAndStockNumber(), e.hasValidVinAndStockNumber)
                if (e.dealerId)
                  switch (e.carExistence) {
                    case A.CarExists:
                      e.setStep(l.CarAlreadyExists);
                      break;
                    case A.CarDoesNotExist:
                      e.allowDataOne ? e.setStep(l.CallingDecode) : e.setStep(l.CallingAddCar);
                      break;
                    default:
                      e.setStep(l.CheckForExisting);
                      break;
                  }
                else
                  e.setStep(l.CallingDecode);
              else
                console.log("[state-machine] Invalid VIN or Stock Number");
            break;
          case l.CarAlreadyExists:
            if (s == k.Forward)
              ((a = e.existingCar) == null ? void 0 : a.carInInventory) == !1 ? (await e.validateStockNumber(), e.carStockNumberExists == !1 ? e.setStep(l.CallingRestoreCar) : console.log("[state-machine] Must change stock number.")) : e.done = !0;
            else if (s == k.Backward)
              if (e.haveShownStep(l.RequestBasics))
                e.setStep(l.RequestBasics);
              else {
                e.done = !0;
                break;
              }
            break;
          case l.SelectTrim:
            s == k.Backward ? e.setStep(l.RequestBasics) : s == k.Forward && e.setStep(l.SelectTransmission);
            break;
          case l.SelectTransmission:
            s == k.Backward ? e.setStep(l.SelectTrim) : s == k.Forward && e.setStep(l.ConfirmDetails);
            break;
          case l.ConfirmDetails:
            s == k.Backward ? e.setStep(l.SelectTrim) : e.setStep(l.CallingAddCar);
            break;
          case l.Error:
            s == k.Backward && e.setStep(l.RequestBasics);
            break;
        }
        e.clearNavigation();
      }
    }), C(() => e.step, async (s, a) => {
      var n, d;
      switch (console.log(`[state-machine] Step: ${a} -> ${s}`), s) {
        case l.RequestBasics:
          e.resetNavigationControls(), e.showContinue = !0;
          break;
        case l.CheckForExisting:
          await e.checkForExistingVin();
          break;
        case l.CarAlreadyExists:
          e.showContinue = ((n = e.existingCar) == null ? void 0 : n.carInInventory) == !1, e.showOk = ((d = e.existingCar) == null ? void 0 : d.carInInventory) == !0, e.showBack = e.haveShownStep(l.RequestBasics);
          break;
        case l.CallingDecode:
          e.showContinue = !1, e.showBack = !0, await e.decodeVin();
          break;
        case l.CallingAddCar:
          e.showContinue = !1, e.showBack = !1, e.allowDataOne ? await e.addCar() : await e.addCarWithoutDataOne();
          break;
        case l.CallingRestoreCar:
          e.showContinue = !1, e.showBack = !1, await e.restoreCarToInventory();
          break;
        case l.SelectTrim:
          e.showContinue = e.hasVehicleId, e.showBack = !0;
          break;
        case l.SelectTransmission:
          e.showContinue = e.hasTransmissionId, e.showBack = !0;
          break;
        case l.ConfirmDetails:
          e.showContinue = !0, e.showBack = !0;
          break;
        case l.Finished:
          e.showCancel = !1, e.showOk = !0;
          break;
        case l.Error:
          e.resetNavigationControls(), e.showBack = !0, e.showCancel = !0;
          break;
        default:
          e.showContinue = !1, e.showBack = !1;
      }
    }), C(() => e.carVin, (s, a) => {
      console.log(`[state-machine] Vin: ${a} -> ${s}`), e.clearDecodedData(), e.clearExistingCar();
    }), C(() => e.carExistence, async (s, a) => {
      var n, d;
      switch (console.log(`[state-machine] CarExistence: ${a} -> ${s}`), s) {
        case A.CarExists:
          ((n = e.existingCar) == null ? void 0 : n.carInInventory) == !1 && (e.carStockNumber.length == 0 && (e.carStockNumber = ((d = e.existingCar) == null ? void 0 : d.carStockNumber) ?? ""), await e.validateStockNumber()), e.setStep(l.CarAlreadyExists);
          break;
        case A.CarDoesNotExist:
          e.hasValidVinAndStockNumber ? e.setStep(l.CallingDecode) : e.setStep(l.RequestBasics);
          break;
      }
    }), C(() => e.styles, (s, a) => {
      switch (console.log(`[state-machine] Styles: ${JSON.stringify(a)} -> ${JSON.stringify(s)}`), s.length) {
        case 0:
          console.log("[state-machine] Styles cleared");
          break;
        case 1:
          var n = s[0].vehicleId ?? "";
          n == e.vehicleId ? console.log(`[state-machine] VehicleId ${n} unchanged, TBD!`) : (console.log(`[state-machine] Setting vehicleId to ${n}`), e.vehicleId = n);
          break;
        default:
          e.setStep(l.SelectTrim);
          break;
      }
    }), C(() => e.vehicle, (s, a) => {
      var d;
      console.log(`[state-machine] Vehicle: ${a} -> ${s}`);
      const n = (d = e.vehicle) == null ? void 0 : d.transmissions;
      if (n !== void 0)
        switch (n == null ? void 0 : n.length) {
          case 0:
            e.setError("No transmissions returned from DataOne");
            break;
          case 1:
            e.setTransmission(n[0]);
            break;
          default:
            e.setStep(l.SelectTransmission);
            break;
        }
    }), C(() => e.vehicleId, (s, a) => {
      const n = e.styles.find((d) => d.vehicleId == e.vehicleId);
      e.$patch({ vehicle: n });
    }), C(() => e.transmission, async (s, a) => {
      if (console.log(`[state-machine] Transmission ${a} -> ${s}`), e.vehicle === void 0 || e.transmission === void 0)
        return;
      const n = { ...e.vehicle };
      n.transmissions = [e.transmission], e.carToAdd = n, e.setStep(l.ConfirmDetails);
    }), C(() => e.transmissionId, (s, a) => {
      var d, c;
      const n = (c = (d = e.vehicle) == null ? void 0 : d.transmissions) == null ? void 0 : c.find((m) => m.transmissionId == e.transmissionId);
      e.$patch({ transmission: n });
    }), C(() => e.optionsUpdated, (s, a) => {
      console.log(`[state-machine] OptionsUpdated ${a} -> ${s}`), e.setStep(l.Finished);
    }), C(() => e.addedCar, (s, a) => {
      console.log(`[state-machine] AddedCar ${a} -> ${s}`), e.setStep(l.Finished), t.closeOnAdd && (e.done = !0);
    }), C(() => e.restoredCar, (s, a) => {
      console.log(`[state-machine] RestoredCar ${a} -> ${s}`), e.setStep(l.Finished), e.done = !0;
    }), C(() => e.error, (s, a) => {
      console.log(`[state-machine] Error ${a} -> ${s}`), e.setStep(l.Error);
    }), console.log("[state-machine] add-car mounted."), e.setDialogTitle("Add Vehicle"), t.carVin && t.dealerId > 0 ? e.setStep(l.CheckForExisting) : e.setStep(l.RequestBasics), e.showContinue = !0;
  });
};
function Lt(t) {
  return "carId" in t ? { machine: Ht(t) } : { machine: Wt(t) };
}
const zt = ["id"], Kt = ["for"], Xt = ["value", "checked", "name", "id"], Re = /* @__PURE__ */ X({
  __name: "choice-list",
  props: {
    items: {},
    itemKey: {},
    modelValue: {},
    group: {}
  },
  emits: ["changed", "update:modelValue"],
  setup(t, { emit: e }) {
    var s;
    const a = t, n = e, d = a.group ?? "group-" + ((s = Ne()) == null ? void 0 : s.uid.toString()) ?? "", c = (r) => r[a.itemKey], m = (r) => "check_" + c(r), E = (r) => c(r) === a.modelValue, b = (r) => {
      n("update:modelValue", r.target.value), n("changed", { group: a.group, key: r.target.value });
    };
    return (r, I) => (h(), p("div", { id: r.group }, [
      (h(!0), p(Me, null, He(r.items, (w) => (h(), p("div", {
        key: c(w),
        class: "form-check d-flex justify-content-between align-items-center border border-1 rounded-3 mb-2 px-3 newest"
      }, [
        i("label", {
          class: "form-check-label flex-grow-1 py-3",
          for: m(w)
        }, [
          We(r.$slots, "label", { item: w }, () => [
            I[0] || (I[0] = T("The label slot is not filled in.."))
          ])
        ], 8, Kt),
        i("input", {
          type: "radio",
          class: "form-check-input",
          value: c(w),
          checked: E(w),
          onChange: b,
          name: o(d),
          id: m(w)
        }, null, 40, Xt)
      ]))), 128))
    ], 8, zt));
  }
}), Jt = { class: "modal show update-wrapper" }, Yt = { class: "modal-dialog" }, Qt = { class: "modal-content" }, Zt = { class: "modal-header" }, es = {
  class: "modal-title",
  id: "myModalLabel"
}, ts = { class: "modal-body" }, ss = { key: 0 }, as = { key: 1 }, rs = {
  key: 0,
  class: "lead ms-2"
}, is = {
  key: 1,
  class: "lead ms-2"
}, os = { class: "container" }, ns = { class: "row mb-3" }, ls = { class: "col" }, ds = { class: "row mb-3" }, cs = { class: "col" }, us = { class: "row mb-3" }, hs = { class: "col" }, ps = {
  key: 0,
  class: "mb-3"
}, ms = {
  key: 0,
  id: "stock-number-help",
  class: "form-text"
}, gs = {
  key: 1,
  class: "mb-3"
}, fs = { key: 2 }, vs = { class: "mb-3" }, ys = {
  key: 0,
  id: "stock-number-help",
  class: "form-text"
}, bs = { class: "mb-3" }, Cs = {
  key: 0,
  id: "stock-number-help",
  class: "form-text"
}, Es = { key: 3 }, qs = { key: 4 }, Is = { key: 5 }, Ts = { key: 6 }, ks = { key: 7 }, ws = { class: "container" }, Ss = { class: "row mb-3" }, Rs = { class: "col" }, Ns = { class: "row mb-3" }, As = { class: "col" }, $s = { class: "row mb-3" }, Ds = { class: "col" }, Os = { class: "row mb-3" }, xs = { class: "col" }, Vs = { class: "row mb-3" }, Gs = { class: "col" }, Bs = { class: "row mb-3" }, Us = { class: "col" }, Ps = {
  key: 0,
  class: "row mb-3"
}, _s = { class: "col" }, js = { class: "row mb-3" }, Fs = { class: "col" }, Ms = { key: 8 }, Hs = { key: 9 }, Ws = { key: 10 }, Ls = { class: "lead" }, zs = { class: "alert alert-success d-flex align-items-center lead" }, Ks = { key: 0 }, Xs = { key: 1 }, Js = { key: 11 }, Ys = { class: "alert alert-danger d-flex align-items-center lead" }, Qs = {
  key: 0,
  class: "modal-footer"
}, Zs = /* @__PURE__ */ X({
  __name: "setup-dialog",
  props: {
    input: {}
  },
  setup(t, { expose: e }) {
    const s = t, a = oe();
    Lt(s.input);
    const n = Le("closeFunc");
    re(() => {
      console.log("dialog mounted with props", s.input);
    }), C(() => a.done, function(b) {
      b && c();
    });
    function d() {
      (a.showContinue || a.showOk) && a.requestNavigate(k.Forward);
    }
    function c() {
      n && n(Ne(), E());
    }
    const m = ze({
      get: () => a.carVin,
      set: (b) => a.carVin = b.trim()
    });
    function E() {
      var r, I, w, x;
      if (a.type === U.AddingCar) {
        var b = O.Cancelled;
        return a.step === l.Finished && a.addedCar ? b = O.CarAdded : a.step === l.Finished && a.restoredCar ? b = O.CarRestored : ((r = a.existingCar) == null ? void 0 : r.carInInventory) == !0 && (b = O.CarAlreadyExists), {
          cancelled: a.step !== l.Finished,
          error: a.error,
          carId: ((I = a.addedCar) == null ? void 0 : I.carId) ?? ((w = a.restoredCar) == null ? void 0 : w.carId) ?? ((x = a.existingCar) == null ? void 0 : x.carId),
          addedCar: a.addedCar ? ke(a.addedCar) : void 0,
          // remove proxy                             
          restoredCar: a.restoredCar ? ke(a.restoredCar) : void 0,
          // remove proxy,
          result: b
        };
      }
      return {
        cancelled: a.step !== l.Finished,
        options: a.optionsUpdated,
        error: a.error
      };
    }
    return e({ returnValue: E }), (b, r) => {
      var I, w, x, ne, le, de, ce, ue, he, pe, me, ge, fe, ve, ye, be, Ce, Ee, qe;
      return h(), p("div", Jt, [
        i("div", Yt, [
          i("div", Qt, [
            i("div", Zt, [
              i("h4", es, y(o(a).dialogTitle), 1),
              i("button", {
                type: "button",
                class: "btn-close close",
                "aria-label": "Close",
                onClick: r[0] || (r[0] = (q) => c())
              })
            ]),
            i("div", ts, [
              o(a).step == o(l).Initial ? (h(), p("div", ss)) : f("", !0),
              o(a).step == o(l).CarAlreadyExists ? (h(), p("div", as, [
                ((I = o(a).existingCar) == null ? void 0 : I.carInInventory) == !0 ? (h(), p("p", rs, r[9] || (r[9] = [
                  i("i", { class: "fas fa-car me-2" }, null, -1),
                  T(" This car already exists in your inventory. ")
                ]))) : f("", !0),
                ((w = o(a).existingCar) == null ? void 0 : w.carInInventory) == !1 ? (h(), p("p", is, r[10] || (r[10] = [
                  i("i", { class: "fas fa-car me-2" }, null, -1),
                  T(" This car already exists but is out of inventory. ")
                ]))) : f("", !0),
                i("div", os, [
                  i("div", ns, [
                    r[11] || (r[11] = i("div", { class: "col-3" }, [
                      i("label", null, "Details")
                    ], -1)),
                    i("div", ls, [
                      i("label", null, y((x = o(a).existingCar) == null ? void 0 : x.carYear) + " " + y((ne = o(a).existingCar) == null ? void 0 : ne.carMake) + " " + y((le = o(a).existingCar) == null ? void 0 : le.carModel), 1)
                    ])
                  ]),
                  i("div", ds, [
                    r[12] || (r[12] = i("div", { class: "col-3" }, [
                      i("label", null, "Trim")
                    ], -1)),
                    i("div", cs, [
                      i("label", null, y((de = o(a).existingCar) == null ? void 0 : de.carColor) + " " + y((ce = o(a).existingCar) == null ? void 0 : ce.carTrim1) + " " + y((ue = o(a).existingCar) == null ? void 0 : ue.carTrim2), 1)
                    ])
                  ]),
                  i("div", us, [
                    r[13] || (r[13] = i("div", { class: "col-3" }, [
                      i("label", null, "VIN")
                    ], -1)),
                    i("div", hs, [
                      i("label", null, y((he = o(a).existingCar) == null ? void 0 : he.carVin), 1)
                    ])
                  ]),
                  ((pe = o(a).existingCar) == null ? void 0 : pe.carInInventory) == !1 && o(a).carStockNumberExists == !0 ? (h(), p("div", ps, [
                    r[14] || (r[14] = i("label", {
                      for: "stockNumberInput",
                      class: "form-label"
                    }, "New Stock Number", -1)),
                    Y(i("input", {
                      type: "text",
                      class: Q(["form-control", { "is-invalid": o(a).carStockNumberValid == !1 }]),
                      id: "stockNumberInput",
                      "onUpdate:modelValue": r[1] || (r[1] = (q) => o(a).carStockNumber = q),
                      onKeyup: Z(d, ["enter"])
                    }, null, 34), [
                      [ee, o(a).carStockNumber]
                    ]),
                    o(a).carStockNumberValid == !1 ? (h(), p("div", ms, y(o(a).carStockNumberExists == !0 ? "The stock number is already used in your inventory." : "The stock number is required and must be more than 3 characters long."), 1)) : f("", !0)
                  ])) : f("", !0),
                  ((me = o(a).existingCar) == null ? void 0 : me.carInInventory) == !1 ? (h(), p("div", gs, r[15] || (r[15] = [
                    i("div", { class: "form-text" }, [
                      i("b", null, [
                        T("Press "),
                        i("span", { class: "badge bg-primary" }, " Continue "),
                        T(" to restore this vehicle to inventory")
                      ]),
                      T(". ")
                    ], -1)
                  ]))) : f("", !0)
                ])
              ])) : f("", !0),
              o(a).step == o(l).RequestBasics ? (h(), p("div", fs, [
                i("form", null, [
                  r[18] || (r[18] = i("div", { class: "mb-3" }, [
                    i("div", { class: "form-text" }, " You can add your vehicle below allowing you to instantly start managing it and assigning media. ")
                  ], -1)),
                  i("div", vs, [
                    r[16] || (r[16] = i("label", {
                      for: "vinInput",
                      class: "form-label"
                    }, "VIN", -1)),
                    Y(i("input", {
                      type: "text",
                      class: Q(["form-control", { "is-invalid": o(a).carVinValid == !1 }]),
                      id: "vinInput",
                      "onUpdate:modelValue": r[2] || (r[2] = (q) => m.value = q),
                      onKeyup: Z(d, ["enter"])
                    }, null, 34), [
                      [ee, m.value]
                    ]),
                    o(a).carVinValid == !1 ? (h(), p("div", ys, "The VIN is required and must be 17 characters long.")) : f("", !0)
                  ]),
                  i("div", bs, [
                    r[17] || (r[17] = i("label", {
                      for: "stockNumberInput",
                      class: "form-label"
                    }, "Stock Number", -1)),
                    Y(i("input", {
                      type: "text",
                      class: Q(["form-control", { "is-invalid": o(a).carStockNumberValid == !1 }]),
                      id: "stockNumberInput",
                      "onUpdate:modelValue": r[3] || (r[3] = (q) => o(a).carStockNumber = q),
                      onKeyup: Z(d, ["enter"])
                    }, null, 34), [
                      [ee, o(a).carStockNumber]
                    ]),
                    o(a).carStockNumberValid == !1 ? (h(), p("div", Cs, y(o(a).carStockNumberExists == !0 ? "The stock number is already used in your inventory." : "The stock number is required and must be more than 3 characters long."), 1)) : f("", !0)
                  ])
                ])
              ])) : f("", !0),
              o(a).step == o(l).CallingUpdate || o(a).step == o(l).CallingDecode || o(a).step == o(l).CheckForExisting ? (h(), p("div", Es, r[19] || (r[19] = [
                i("p", { class: "lead ms-2" }, [
                  i("i", { class: "fas fa-globe fa-spin me-2" }),
                  T(" Looking up car details.. ")
                ], -1)
              ]))) : f("", !0),
              o(a).step == o(l).CallingUpdateAgain ? (h(), p("div", qs, r[20] || (r[20] = [
                i("p", { class: "lead ms-2" }, [
                  i("i", { class: "fas fa-globe fa-spin me-2" }),
                  T(" Updating options.. ")
                ], -1)
              ]))) : f("", !0),
              o(a).step == o(l).SelectTrim ? (h(), p("div", Is, [
                r[22] || (r[22] = i("p", { class: "lead ms-2" }, [
                  i("i", { class: "fas fa-car me-2" }),
                  T(" Choose a specific trim ")
                ], -1)),
                ae(o(Re), {
                  group: "trimSelection",
                  items: o(a).getStyles,
                  itemKey: "vehicleId",
                  modelValue: o(a).vehicleId,
                  "onUpdate:modelValue": r[4] || (r[4] = (q) => o(a).vehicleId = q)
                }, {
                  label: se(({ item: q }) => [
                    T(y(q.year) + " " + y(q.make) + " " + y(q.model) + " ", 1),
                    r[21] || (r[21] = i("br", null, null, -1)),
                    T(" " + y(q.styleName), 1)
                  ]),
                  _: 1
                }, 8, ["items", "modelValue"])
              ])) : f("", !0),
              o(a).step == o(l).SelectTransmission ? (h(), p("div", Ts, [
                r[23] || (r[23] = i("p", { class: "lead ms-2" }, [
                  i("i", { class: "fas fa-car me-2" }),
                  T(" Choose the transmission ")
                ], -1)),
                ae(o(Re), {
                  group: "transSelection",
                  items: o(a).getTransmissions,
                  itemKey: "transmissionId",
                  modelValue: o(a).transmissionId,
                  "onUpdate:modelValue": r[5] || (r[5] = (q) => o(a).transmissionId = q)
                }, {
                  label: se(({ item: q }) => [
                    T(y(q.transmissionName), 1)
                  ]),
                  _: 1
                }, 8, ["items", "modelValue"])
              ])) : f("", !0),
              o(a).step == o(l).ConfirmDetails ? (h(), p("div", ks, [
                r[32] || (r[32] = i("p", { class: "lead ms-2" }, [
                  i("i", { class: "fas fa-car me-2" }),
                  T(" Confirm these details ")
                ], -1)),
                i("div", ws, [
                  i("div", Ss, [
                    r[24] || (r[24] = i("div", { class: "col-3" }, [
                      i("label", null, "Stock #")
                    ], -1)),
                    i("div", Rs, [
                      i("label", null, y(o(a).carStockNumber), 1)
                    ])
                  ]),
                  i("div", Ns, [
                    r[25] || (r[25] = i("div", { class: "col-3" }, [
                      i("label", null, "Year")
                    ], -1)),
                    i("div", As, [
                      i("label", null, y((ge = o(a).carToAdd) == null ? void 0 : ge.year), 1)
                    ])
                  ]),
                  i("div", $s, [
                    r[26] || (r[26] = i("div", { class: "col-3" }, [
                      i("label", null, "Make")
                    ], -1)),
                    i("div", Ds, [
                      i("label", null, y((fe = o(a).carToAdd) == null ? void 0 : fe.make), 1)
                    ])
                  ]),
                  i("div", Os, [
                    r[27] || (r[27] = i("div", { class: "col-3" }, [
                      i("label", null, "Model")
                    ], -1)),
                    i("div", xs, [
                      i("label", null, y((ve = o(a).carToAdd) == null ? void 0 : ve.model), 1)
                    ])
                  ]),
                  i("div", Vs, [
                    r[28] || (r[28] = i("div", { class: "col-3" }, [
                      i("label", null, "Style")
                    ], -1)),
                    i("div", Gs, [
                      i("label", null, y((ye = o(a).carToAdd) == null ? void 0 : ye.styleName), 1)
                    ])
                  ]),
                  i("div", Bs, [
                    r[29] || (r[29] = i("div", { class: "col-3" }, [
                      i("label", null, "Engine")
                    ], -1)),
                    i("div", Us, [
                      i("label", null, y((be = o(a).carToAdd) == null ? void 0 : be.engine), 1)
                    ])
                  ]),
                  (Ce = o(a).carToAdd) != null && Ce.transmissions ? (h(), p("div", Ps, [
                    r[30] || (r[30] = i("div", { class: "col-3" }, [
                      i("label", null, "Transmission")
                    ], -1)),
                    i("div", _s, [
                      i("label", null, y((Ee = o(a).carToAdd) == null ? void 0 : Ee.transmissions[0].transmissionName), 1)
                    ])
                  ])) : f("", !0),
                  i("div", js, [
                    r[31] || (r[31] = i("div", { class: "col-3" }, [
                      i("label", null, "VIN")
                    ], -1)),
                    i("div", Fs, [
                      i("label", null, y(o(a).carVin), 1)
                    ])
                  ])
                ])
              ])) : f("", !0),
              o(a).step == o(l).CallingAddCar ? (h(), p("div", Ms, r[33] || (r[33] = [
                i("p", { class: "lead ms-2" }, [
                  i("i", { class: "fas fa-globe fa-spin me-2" }),
                  T(" Adding car... ")
                ], -1)
              ]))) : f("", !0),
              o(a).step == o(l).CallingRestoreCar ? (h(), p("div", Hs, r[34] || (r[34] = [
                i("p", { class: "lead ms-2" }, [
                  i("i", { class: "fas fa-globe fa-spin me-2" }),
                  T(" Restoring car to inventory... ")
                ], -1)
              ]))) : f("", !0),
              o(a).step == o(l).Finished ? (h(), p("div", Ws, [
                i("p", Ls, [
                  i("div", zs, [
                    r[35] || (r[35] = i("i", { class: "fas fa-check me-2" }, null, -1)),
                    o(a).type == o(U).UpdatingOptions ? (h(), p("div", Ks, " Finished! " + y(o(a).optionsUpdated) + " options updated ", 1)) : f("", !0),
                    o(a).type == o(U).AddingCar ? (h(), p("div", Xs, " Finished! Car added to inventory. ")) : f("", !0)
                  ])
                ])
              ])) : f("", !0),
              o(a).step == o(l).Error ? (h(), p("div", Js, [
                i("div", Ys, [
                  r[36] || (r[36] = i("i", { class: "icon far fa-frown me-2" }, null, -1)),
                  i("div", null, y((qe = o(a).error) == null ? void 0 : qe.message), 1)
                ])
              ])) : f("", !0)
            ]),
            o(a).showBack || o(a).showContinue || o(a).showOk || o(a).showCancel ? (h(), p("div", Qs, [
              o(a).showBack ? (h(), p("button", {
                key: 0,
                class: "btn btn-primary me-auto",
                onClick: r[6] || (r[6] = (q) => o(a).requestNavigate(o(k).Backward))
              }, r[37] || (r[37] = [
                i("i", {
                  class: "fas fa-chevron-left me-2",
                  "aria-hidden": "true"
                }, null, -1),
                T("Back")
              ]))) : f("", !0),
              o(a).showCancel ? (h(), p("button", {
                key: 1,
                type: "button",
                class: "btn btn-default",
                onClick: r[7] || (r[7] = (q) => c())
              }, "Cancel")) : f("", !0),
              o(a).showOk ? (h(), p("button", {
                key: 2,
                class: "btn btn-primary",
                onClick: r[8] || (r[8] = (q) => c())
              }, "OK")) : f("", !0),
              o(a).showContinue ? (h(), p("button", {
                key: 3,
                class: "btn btn-primary",
                onClick: d
              }, r[38] || (r[38] = [
                T(" Continue "),
                i("i", {
                  class: "fas fa-chevron-right ms-2",
                  "aria-hidden": "true"
                }, null, -1)
              ]))) : f("", !0)
            ])) : f("", !0)
          ])
        ])
      ]);
    };
  }
});
let B = null;
function ea(t) {
  _t(t.fieldServiceBaseUrl), B != null && (B.unmount(), B = null);
}
async function Ve(t, e) {
  return B == null && (B = Ke(Ft), B.use(Qe), B.use(Je()), B.mount(t)), await Ye(Zs, { input: e });
}
const ta = async (t, e) => Ve(t, e), sa = async (t, e) => Ve(t, e), aa = {
  initialize: ea,
  showUpdateOptionsDialog: ta,
  showAddCarDialog: sa
};
window.setupCar = aa;
export {
  aa as default
};
//# sourceMappingURL=car-setup.es.js.map
